import {
  createEmptyDirectValues,
  createEmptyBaseFees,
  createEmptyDemandMultipliers,
} from "./pricing-transformers";

export const PRICING_MODELS = {
  BASE_MULTIPLIER: "baseMultiplier",
  DIRECT_VALUES: "directValues",
  HYBRID: "hybrid",
};

export const AUDIT_ACTIONS = {
  MODEL_SWITCH: "MODEL_SWITCH",
  UPDATE_BASE_FEES: "UPDATE_BASE_FEES",
  UPDATE_MULTIPLIERS: "UPDATE_MULTIPLIERS",
  UPDATE_DIRECT_VALUES: "UPDATE_DIRECT_VALUES",
  SAVE_OVERRIDE: "SAVE_OVERRIDE",
  DELETE_OVERRIDE: "DELETE_OVERRIDE",
};

export const MAX_AUDIT_LOG_LENGTH = 20;

export const createPricingInitialState = () => ({
  // Legacy fields (locality-based)
  configs: [],
  config: null,

  // Loading states
  isLoading: false,
  modelSwitchInProgress: false,
  message: null,

  // Flexible pricing model fields
  currentPricingModel: PRICING_MODELS.BASE_MULTIPLIER,
  baseFeesModel: createEmptyBaseFees(),
  demandMultipliers: createEmptyDemandMultipliers(),
  directValues: createEmptyDirectValues(),
  overrides: [],
  lastChanges: [],
});
